import { toAbsolutePhotoUrl } from "../../../services/trombinosServices";

export const FALLBACK_TROMBINO_PHOTO = "/img/no-image.jpg";

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function ensureArray(value) {
  return Array.isArray(value) ? value : [];
}

export function normalizeSearchText(value = "") {
  return String(value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

export function toBoolean(value) {
  return value === true || value === 1 || value === "1";
}

export function getFullName(person) {
  return [person?.prenom, person?.nom]
    .filter(Boolean)
    .map((value) => String(value).trim())
    .join(" ")
    .trim();
}

export function getServiceLabel(service) {
  return service?.nom_service || "";
}

export function normalizeTrombinoPerson(person) {
  const fullName = getFullName(person) || "Nom inconnu";
  const fonction = person?.fonction || "";
  const groupe = person?.groupe || "";
  const serviceLabel = getServiceLabel(person?.service);
  const isElected = toBoolean(person?.is_elected);

  const photo = person?.photo_url
    ? toAbsolutePhotoUrl(person.photo_url)
    : FALLBACK_TROMBINO_PHOTO;

  const displayOrder = Number(
    person?.ordre_affichage ??
      person?.order_affichage ??
      person?.display_order ??
      person?.ordre ??
      9999,
  );

  const normalized = {
    id: person?.id,
    raw: person,

    nom: person?.nom || "",
    prenom: person?.prenom || "",
    fullName,
    initials: fullName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0])
      .join("")
      .toUpperCase(),

    fonction,
    groupe,

    service: person?.service || null,
    serviceId: person?.service_id || person?.service?.id || null,
    serviceLabel,

    isElected,
    roleLabel: isElected ? "Conseil municipal" : "Service municipal",

    mail: person?.mail_pro || "",
    phone: person?.tel_pro || "",
    phoneHref: person?.tel_pro
      ? `tel:${String(person.tel_pro).replace(/\s+/g, "")}`
      : "",

    presentation: person?.presentation_courte || "",

    photo,

    displayOrder: Number.isFinite(displayOrder) ? displayOrder : 9999,
  };

  normalized.searchIndex = normalizeSearchText(
    [
      normalized.fullName,
      normalized.fonction,
      normalized.groupe,
      normalized.serviceLabel,
      normalized.mail,
      normalized.phone,
      normalized.presentation,
      normalized.roleLabel,
    ]
      .filter(Boolean)
      .join(" "),
  );

  return normalized;
}

export function sortTrombinos(items) {
  return [...items].sort((a, b) => {
    if (a.displayOrder !== b.displayOrder) {
      return a.displayOrder - b.displayOrder;
    }

    const electedA = a.isElected ? 0 : 1;
    const electedB = b.isElected ? 0 : 1;

    if (electedA !== electedB) return electedA - electedB;

    return normalizeSearchText(a.fullName).localeCompare(
      normalizeSearchText(b.fullName),
      "fr",
    );
  });
}
